var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//region import

// models
import model from '../base.model';
import { loginModel } from '../auth/login.model';

// constants
import urls from '../../constants/urls.constant';

// storage
import { getServerUrl as settingsGetServerUrl } from '../../device/settings.storage';

// utils
import { getIconByType } from '../../services/service/weather.helper';

//endregion


class weatherModel extends model {
    //region init

    constructor(props) {
        super(props);
    }

    static create() {
        return _extends({}, super.create(), {
            weatherStatus: {
                isLoading: false
            }
        });
    }

    //endregion
    //region model

    static processServerResponse(dispatch, params, model, serverResponse, history) {}

    static isClientEmpty(clientModel) {
        return !clientModel;
    }

    static getReduceMethod(model, type) {
        const reduceMethod = super.getReduceMethod(model, type);
        if (reduceMethod) {
            return reduceMethod;
        }
        const reducers = {
            [model.TYPE_REQUEST_WEATHER_STATUS]: model.reduceRequestWeatherStatus.bind(model),
            [model.TYPE_GET_WEATHER_STATUS]: model.reduceGetWeatherStatus.bind(model)
        };

        return reducers[type];
    }

    //endregion
    //region api get weather status

    static apiGetWeatherStatus(clientApiMethod, params = {}, dispatch, failAction) {
        var _this = this;

        return _asyncToGenerator(function* () {
            const serverModel = _this.mapWeatherStatusToServer(params);
            const { urlParams } = serverModel;
            const authData = yield loginModel.storageGetAuthToken(loginModel);
            const { authToken } = authData;
            const serverUrl = yield settingsGetServerUrl();
            const url = urls.core.getWeatherStatus(urlParams);

            dispatch(_this.actionRequestWeatherStatus(_this, { modelClient: { isLoading: true }, model: _this }));

            return clientApiMethod(serverUrl, url, serverModel.payload, authToken).then(function (serverResponse) {
                const modelClient = _this.mapWeatherStatusToClient(serverResponse, params);
                dispatch(_this.actionGetWeatherStatus(_this, { modelClient, model: _this }));
            }).catch(function (error) {
                _this.catchRequest(_this, dispatch, failAction)(error);
                dispatch(_this.actionRequestWeatherStatus(_this, { modelClient: { isLoading: false, isError: true }, model: _this }));
            });
        })();
    }

    static actionRequestWeatherStatus(model, payload) {
        return {
            type: model.TYPE_REQUEST_WEATHER_STATUS,
            payload
        };
    }

    static reduceRequestWeatherStatus(stateModel, action, state) {
        const { modelClient, model } = action.payload;
        return {
            [model.MODEL_NAME]: _extends({}, stateModel, {
                weatherStatus: _extends({}, stateModel.weatherStatus, {
                    isLoading: modelClient.isLoading,
                    isError: modelClient.isError || false
                })
            })
        };
    }

    static actionGetWeatherStatus(model, payload) {
        return {
            type: model.TYPE_GET_WEATHER_STATUS,
            payload
        };
    }

    static mapWeatherStatusToClient(serverResponse, params) {
        const { weatherStatus } = this.create();
        if (!serverResponse) {
            return weatherStatus;
        }

        return {
            weatherStatus: {
                temperature: serverResponse.temperature,
                humidity: serverResponse.humidity,
                pressure: serverResponse.pressure,
                status: serverResponse.status,
                time: serverResponse.time,
                icon: getIconByType(serverResponse.status)
            }
        };
    }

    static mapWeatherStatusToServer(clientModel) {
        if (super.isEmpty(clientModel)) {
            return {
                urlParams: {}
            };
        }

        return {
            urlParams: {}
        };
    }

    static reduceGetWeatherStatus(stateModel, action) {
        const { modelClient, model } = action.payload;
        return {
            [model.MODEL_NAME]: _extends({}, stateModel, modelClient)
        };
    }
}

weatherModel.MODEL_NAME = 'weatherModel';
weatherModel.TYPE_REQUEST = 'REQUEST_WEATHER';
weatherModel.TYPE_FROM_SERVER = 'GET_WEATHER';
weatherModel.TYPE_CLEAR = 'CLEAR_WEATHER';
weatherModel.TYPE_REQUEST_WEATHER_STATUS = 'TYPE_REQUEST_WEATHER_STATUS';
weatherModel.TYPE_GET_WEATHER_STATUS = 'TYPE_GET_WEATHER_STATUS';
export { weatherModel };


// WEBPACK FOOTER //
// ./~/pluton-core/lib/models/service/weather.model.js